import { render, staticRenderFns } from "./testmap.vue?vue&type=template&id=3688153b&scoped=true&"
import script from "./testmap.vue?vue&type=script&lang=js&"
export * from "./testmap.vue?vue&type=script&lang=js&"
import style0 from "./testmap.vue?vue&type=style&index=0&id=3688153b&lang=scss&scoped=true&"
import style1 from "./testmap.vue?vue&type=style&index=1&id=3688153b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688153b",
  null
  
)

export default component.exports